import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    departmentsWrapper: {
        marginTop: '50px',
    },
}));

export { useStyles };